import type { LocationDescriptor } from 'history';
import type { HTMLAttributes } from 'react';

export interface CardItemBreedSeoData {
  image?: string;
  breedName: string;
  link?: LocationDescriptor;
}

export interface CardItemBreedSeoProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick'>,
    CardItemBreedSeoData {}
